import { Icon } from "@iconify/react";
import React, { useEffect, useState } from "react";
import axios from "axios";
import { BASE_URL } from "../../helpers/api";

// Falls back to Medayus's real brand profiles if the /settings API call
// fails or hasn't resolved yet, so the footer never renders empty.
const DEFAULT_LINKS = {
  facebook_url: "https://facebook.com/medayushospital",
  twitter_url: "https://x.com/medayushospital",
  instagram_url: "https://instagram.com/medayushospital",
  linkedin_url: "https://linkedin.com/company/medayushospital",
  youtube_url: "https://youtube.com/@medayushospital",
};

// Order controls display order; icon/label are keyed off the same
// setting.<key>_url columns the Admin Panel's Settings screen writes to.
const PLATFORMS = [
  { key: "facebook_url", icon: "fa-brands:facebook-f", label: "Facebook" },
  { key: "twitter_url", icon: "fa-brands:twitter", label: "Twitter" },
  { key: "instagram_url", icon: "fa-brands:instagram", label: "Instagram" },
  { key: "linkedin_url", icon: "fa-brands:linkedin-in", label: "LinkedIn" },
  { key: "youtube_url", icon: "fa-brands:youtube", label: "YouTube" },
];

export default function SocialWidget() {
  const [links, setLinks] = useState(DEFAULT_LINKS);

  useEffect(() => {
    axios
      .get(`${BASE_URL}/settings`)
      .then((res) => {
        if (res.data && Object.keys(res.data).length) {
          setLinks((prev) => ({ ...prev, ...res.data }));
        }
      })
      .catch(() => {
        // keep DEFAULT_LINKS
      });
  }, []);

  const active = PLATFORMS.filter((p) => links[p.key]);

  return (
    <div className="cs_social_links_wrap">
      <h2>Follow Us</h2>
      <div className="cs_social_links">
        {active.map((p) => (
          <a
            key={p.key}
            href={links[p.key]}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={p.label}
          >
            <Icon icon={p.icon} />
          </a>
        ))}
      </div>
    </div>
  );
}
